import { Link } from "react-router-dom";
import './StackedCards.css';

import { ArrowPathIcon, PaperAirplaneIcon } from '@heroicons/react/20/solid';

const steps = [
    {
        title: "Select Source Platform",
        description: "Choose the platform from which you want to transfer your playlists.",
        number: "01"
    },
    {
        title: "Select Destination Platform",
        description: "Choose the platform where you want to transfer your playlists to.",
        number: "02"
    },
    {
        title: "Authorize Accounts",
        description: "Authorize your accounts to allow the transfer of playlists between platforms.",
        number: "03"
    },
    {
        title: "Transfer Playlists",
        description: "Initiate the transfer process and enjoy your playlists on the new platform.",
        number: "04"
    }
];

const features = [
  {
    name: 'Transfer Playlists',
    description:
      'Transfer your playlists from Spotify, Apple Music, and YouTube with ease.',
    icon:  PaperAirplaneIcon,
    link: '/sync-playlists'
  },
  {
name: 'Sync Playlists',
    description: 'Sync your playlists between platforms.',
    icon: ArrowPathIcon,
    link: "/transfer-playlists-and-songs"
  },

]


export default function StackedCards() {

    return (
        <div className="max-w-7xl h-auto flex items-center justify-center flex-none px-4 mx-auto mb-8 bg-white dark:bg-zinc-950 stack-container py-24 sm:py-8">
            <div className="w-full flex flex-col items-center justify-center relative">
                <div className="w-full flex flex-row items-start gap-16">
                    <div className="items-start w-full grid gap-8 grid-cols-2 thq-grid-2 ">
                        <div className="flex flex-col items-start gap-6 sticky steps-section-header">
                            <h2 className="text-3xl sm:text-2xl font-extrabold leading-tight tracking-tight text-balance text-gray-900 dark:text-white">Discover the Power of Our Products</h2>
                            <p className="text-lg font-light text-gray-900 dark:text-gray-400">
                                Move your music collection from Spotify, Apple Music, and YouTube with ease. Music Porter makes it simple to migrate playlists, sync your favorite tracks, and enjoy your music library across all your streaming platforms—no manual effort required.
                            </p>

                            <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-gray-400 lg:max-w-none">
                            {features.map((feature) => (
                            <div key={feature.name} className="relative pl-9">
                                <dt className=" font-semibold text-gray-900 dark:text-white flex items-center">
                                
                                <feature.icon aria-hidden="true" className="mr-2 size-5 text-gray-900 dark:text-white" />
                                
                                <Link to={feature.link} className="text-center text-gray-900  sm:w-auto hover:text-gray-400 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:text-gray-400">{feature.name}</Link>
                                </dt>{' '}
                                <dd className=" text-gray-900 dark:text-gray-400">{feature.description}</dd>
                            </div>
                            ))}
                        </dl>

                            <div className="space-y-4 sm:flex sm:space-y-0 sm:space-x-4">
                                <Link
                                    to="/login"
                                    className="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-medium text-center text-white bg-purple-700 border border-transparent rounded-lg sm:w-auto hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
                                >
                                    Transfer Playlists Free
                                </Link>
                            </div>
                        </div>
                        <div className="steps-stack-container">
                            {steps.map((step, index) => (
                                <div
                                    key={step.number}
                                    className={`mb-10 flex flex-col gap-6 p-8 items-stretch ring-1 ring-gray-200 dark:ring-white/10 shadow-md rounded-lg ${index % 2 === 0
                                        ? 'steps-stack-even bg-white dark:bg-zinc-950'
                                        : 'steps-stack-odd bg-gray-200 dark:bg-zinc-900'
                                        }`}
                                >
                                    <h2 className="text-3xl font-semibold text-gray-900 dark:text-white">{step.title}</h2>
                                    <span className="text-center font-light text-gray-900 dark:text-gray-400">{step.description}</span>
                                    <label className="steps-content text-2xl font-semibold text-gray-900 dark:text-gray-400">{step.number}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
